import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
  Loading, Pagination, Button,
} from '../../components/base';
import {
  getPositionsList,
  getPositionDetail,
  createPosition,
  updatePosition,
  deletePosition,
} from '../../states/thunks/settings.thunk';

const MySwal = withReactContent(Swal);

class JabatanStruktural extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      positions: [],
      currentPosition: {
        id: '',
        name: '',
        code: '',
        automated: false,
      },
      isEdit: false,
      pagination: {
        page: 1,
        limit: 10,
        totalData: 0,
      },
    };

    this._getPositionsOptions = this._getPositionsOptions.bind(this);
    this._handleOpenModal = this._handleOpenModal.bind(this);
    this._handleInputChange = this._handleInputChange.bind(this);
    this._handleSavePosition = this._handleSavePosition.bind(this);
    this._handleEditPosition = this._handleEditPosition.bind(this);
    this._handleDeletePosition = this._handleDeletePosition.bind(this);
    this._handlePageChange = this._handlePageChange.bind(this);
    this._renderModalContent = this._renderModalContent.bind(this);
    this._getPositionDetail = this._getPositionDetail.bind(this);
  }

  componentDidMount() {
    this._getPositionsOptions();
  }

  async _getPositionsOptions() {
    this.setState({ isLoading: true });
    try {
      const positions = await this.props.getPositionsList();

      if (positions && positions.length > 0) {
        const formattedPositions = positions.map(position => ({
          value: position.id,
          label: position.name,
          code: position.code,
          automated: position.automated || false,
        }));

        this.setState({
          positions: formattedPositions,
          pagination: {
            ...this.state.pagination,
            totalData: formattedPositions.length,
            totalItemsCount: formattedPositions.length,
          },
          isLoading: false,
        });
      } else {
        this.setState({
          positions: [],
          isLoading: false,
        });
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching positions:', error);
      this.setState({ isLoading: false });

      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Gagal mengambil data jabatan struktural',
      });
    }
  }

  async _getPositionDetail(id) {
    this.setState({ isLoading: true });
    try {
      const positionData = await this.props.getPositionDetail(id);

      if (positionData) {
        this.setState({
          currentPosition: {
            id: positionData.id,
            name: positionData.name,
            code: positionData.code || '',
            automated: positionData.automated || false,
          },
          isLoading: false,
        });

        return positionData;
      }

      this.setState({ isLoading: false });
      return null;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching position detail:', error);
      this.setState({ isLoading: false });

      MySwal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Gagal mengambil detail jabatan',
      });

      return null;
    }
  }

  _handleOpenModal(position = null) {
    if (position) {
      // For edit, first get the detailed data
      this.setState({
        isLoading: true,
        currentPosition: {
          id: position.value,
          name: position.label,
          code: position.code || '',
          automated: position.automated || false,
        },
        isEdit: true,
      }, async () => {
        try {
          const positionData = await this._getPositionDetail(position.value);
          
          // If we got data back, update the state with it
          if (positionData) {
            this.setState({
              currentPosition: {
                id: positionData.id,
                name: positionData.name,
                code: positionData.code || '',
                automated: positionData.automated || false,
              },
            });
          }
        } catch (error) {
          console.error('Error getting position details:', error);
        }
        
        this.setState({ isLoading: false }, () => {
          this._showModal('Edit Jabatan');
        });
      });
    } else {
      this.setState({
        currentPosition: {
          id: '',
          name: '',
          code: '',
          automated: false,
        },
        isEdit: false,
      }, () => {
        this._showModal('Tambah Jabatan');
      });
    }
  }

  _showModal(title) {
    const self = this;
    MySwal.fire({
      title: <p>{title}</p>,
      width: '600px',
      html: this._renderModalContent(),
      showCancelButton: true,
      confirmButtonText: 'Simpan',
      cancelButtonText: 'Batal',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      preConfirm: () => this._handleSavePosition(),
      didOpen: () => {
        // Get references to the input elements
        const nameInput = Swal.getPopup().querySelector('#name');
        const codeInput = Swal.getPopup().querySelector('#code');
        const automatedCheckbox = Swal.getPopup().querySelector('#automated');

        // Set initial values from state
        nameInput.value = self.state.currentPosition.name;
        codeInput.value = self.state.currentPosition.code;
        
        // Make sure the checkbox is properly set based on the currentPosition state
        if (automatedCheckbox) {
          automatedCheckbox.checked = self.state.currentPosition.automated === true;
        }

        // Add event listeners
        nameInput.addEventListener('input', (e) => {
          self.setState(prevState => ({
            currentPosition: {
              ...prevState.currentPosition,
              name: e.target.value,
            },
          }));
        });

        codeInput.addEventListener('input', (e) => {
          self.setState(prevState => ({
            currentPosition: {
              ...prevState.currentPosition,
              code: e.target.value,
            },
          }));
        });

        automatedCheckbox.addEventListener('change', (e) => {
          self.setState(prevState => ({
            currentPosition: {
              ...prevState.currentPosition,
              automated: e.target.checked,
            },
          }));
        });
      },
    });
  }

  _renderModalContent() {
    const { currentPosition } = this.state;
    
    return (
      <div className="position__form" style={{ padding: '20px' }}>
        <div className="form-group" style={{ marginBottom: '20px' }}>
          <label
            htmlFor="name"
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            Nama Jabatan *
          </label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            placeholder="Masukkan nama jabatan"
            required
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '14px',
              height: '40px',
              boxSizing: 'border-box',
            }}
          />
        </div>
        <div className="form-group" style={{ marginBottom: '20px' }}>
          <label
            htmlFor="code"
            style={{
              display: 'block',
              marginBottom: '8px',
              fontWeight: 'bold',
              fontSize: '14px',
            }}
          >
            Kode Jabatan *
          </label>
          <input
            type="text"
            className="form-control"
            id="code"
            name="code"
            placeholder="Masukkan kode jabatan"
            required
            style={{
              width: '100%',
              padding: '10px 12px',
              borderRadius: '4px',
              border: '1px solid #ddd',
              fontSize: '14px',
              height: '40px',
              boxSizing: 'border-box',
            }}
          />
        </div>
        <div className="form-group" style={{ marginBottom: '20px' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <input
              type="checkbox"
              className="form-control"
              id="automated"
              name="automated"
              style={{
                width: '20px',
                height: '20px',
                marginRight: '10px',
              }}
              defaultChecked={currentPosition.automated}
            />
            <label
              htmlFor="automated"
              style={{
                fontWeight: 'bold',
                fontSize: '14px',
                marginBottom: '0',
              }}
            >
              Diisi oleh sistem
            </label>
          </div>
        </div>
      </div>
    );
  }

  _handleInputChange(e) {
    const { name, value } = e.target;
    this.setState(prevState => ({
      currentPosition: {
        ...prevState.currentPosition,
        [name]: value,
      },
    }));
  }

  async _handleSavePosition() {
    // Get values directly from the SweetAlert2 popup inputs
    const nameInput = Swal.getPopup().querySelector('#name');
    const codeInput = Swal.getPopup().querySelector('#code');
    const automatedCheckbox = Swal.getPopup().querySelector('#automated');

    const name = nameInput ? nameInput.value : '';
    const code = codeInput ? codeInput.value : '';
    const automated = automatedCheckbox ? automatedCheckbox.checked : false;

    if (!name || !code) {
      MySwal.showValidationMessage('Nama dan Kode Jabatan harus diisi');
      return false;
    }

    this.setState({ isLoading: true });

    try {
      const { isEdit, currentPosition } = this.state;
      const payload = {
        name,
        code,
        automated,
      };

      let response;

      if (isEdit) {
        // Edit existing position
        response = await this.props.updatePosition(currentPosition.id, payload);
      } else {
        // Create new position
        response = await this.props.createPosition(payload);
      }

      if (response && response.status === 'success') {
        // Refresh the positions list with the latest data from API
        await this._getPositionsOptions();

        this.setState({ isLoading: false });

        MySwal.fire({
          icon: 'success',
          title: 'Berhasil',
          text: isEdit ? 'Data jabatan berhasil diperbarui' : 'Data jabatan berhasil disimpan',
        }).then(() => {
          // Ensure we refresh the data after the success message is closed
          this._getPositionsOptions();
        });

        return true;
      }

      this.setState({ isLoading: false });
      MySwal.showValidationMessage(response && response.message ? response.message : 'Terjadi kesalahan saat menyimpan data');
      return false;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error saving position:', error);
      this.setState({ isLoading: false });
      MySwal.showValidationMessage('Terjadi kesalahan saat menyimpan data');
      return false;
    }
  }

  _handleEditPosition(position) {
    this._handleOpenModal(position);
  }

  async _handleDeletePosition(positionId) {
    const result = await MySwal.fire({
      title: 'Apakah Anda yakin?',
      text: 'Data yang dihapus tidak dapat dikembalikan!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Ya, hapus!',
      cancelButtonText: 'Batal',
    });

    if (result.isConfirmed) {
      this.setState({ isLoading: true });

      try {
        const response = await this.props.deletePosition(positionId);

        if (response && response.status === 'success') {
          // Refresh the positions list with the latest data from API
          await this._getPositionsOptions();

          MySwal.fire({
            icon: 'success',
            title: 'Terhapus!',
            text: 'Data jabatan berhasil dihapus.',
          }).then(() => {
            // Ensure we refresh the data after the success message is closed
            this._getPositionsOptions();
          });
        } else {
          throw new Error(response && response.message ? response.message : 'Gagal menghapus data');
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error deleting position:', error);
        this.setState({ isLoading: false });
        MySwal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Terjadi kesalahan saat menghapus data.',
        });
      }
    }
  }

  _handlePageChange(page) {
    this.setState(prevState => ({
      pagination: {
        ...prevState.pagination,
        page,
      },
    }));
  }

  _renderPositionList() {
    const { positions, pagination } = this.state;
    const { page, limit } = pagination;

    const startIndex = (page - 1) * limit;
    const endIndex = startIndex + limit;
    const paginatedPositions = positions.slice(startIndex, endIndex);
    
    return (
      <table className="table">
        <thead>
          <tr>
            <th>No</th>
            <th>Nama Jabatan</th>
            <th>Kode Jabatan</th>
            <th>Diisi oleh sistem</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {paginatedPositions.length > 0 ? (
            paginatedPositions.map((position, index) => (
              <tr key={position.value}>
                <td>{startIndex + index + 1}</td>
                <td>{position.label}</td>
                <td>{position.code || '-'}</td>
                <td>{position.automated ? 'Ya' : 'Tidak'}</td>
                <td>
                  <Button
                    title="Edit"
                    onClick={() => this._handleEditPosition(position)}
                  />
                  {' '}
                  <Button
                    title="Hapus"
                    onClick={() => this._handleDeletePosition(position.value)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center">Tidak ada data</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  render() {
    const {
      isLoading, pagination,
    } = this.state;

    return (
      <div className="position">
        <div className="position__header">
          <h1>Jabatan Struktural</h1>
          <Button
            title="Tambah Jabatan"
            onClick={() => this._handleOpenModal()}
          />
        </div>

        {isLoading ? (
          <Loading />
        ) : (
          <>
            {this._renderPositionList()}

            <Pagination
              activePage={pagination.page}
              itemsCountPerPage={pagination.limit}
              totalItemsCount={pagination.totalItemsCount}
              onChange={this._handlePageChange}
            />
          </>
        )}
      </div>
    );
  }
}

JabatanStruktural.propTypes = {
  getPositionsList: PropTypes.func.isRequired,
  getPositionDetail: PropTypes.func.isRequired,
  createPosition: PropTypes.func.isRequired,
  updatePosition: PropTypes.func.isRequired,
  deletePosition: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = {
  getPositionsList,
  getPositionDetail,
  createPosition,
  updatePosition,
  deletePosition,
};

export default connect(mapStateToProps, mapDispatchToProps)(JabatanStruktural);
